// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3H3_6","messages":"Chat_messages__2Lbn7","dateDivider":"Chat_dateDivider__3II_P"};